import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_sentryserver_0f71d9b7 from 'nuxt_plugin_sentryserver_0f71d9b7' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_ac8f2fa2 from 'nuxt_plugin_sentryclient_ac8f2fa2' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_recaptcha_e914cc3c from 'nuxt_plugin_recaptcha_e914cc3c' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_gtm_3ce82489 from 'nuxt_plugin_gtm_3ce82489' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_nuxtsvgsprite_0e574451 from 'nuxt_plugin_nuxtsvgsprite_0e574451' // Source: ./nuxt-svg-sprite.js (mode: 'all')
import nuxt_plugin_vuescrollto_cc633c94 from 'nuxt_plugin_vuescrollto_cc633c94' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_pluginutils_76ee54b0 from 'nuxt_plugin_pluginutils_76ee54b0' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_7baa98f3 from 'nuxt_plugin_pluginrouting_7baa98f3' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_577f2f5c from 'nuxt_plugin_pluginmain_577f2f5c' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_axios_0486bcf3 from 'nuxt_plugin_axios_0486bcf3' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_metaplugin_627b6d3c from 'nuxt_plugin_metaplugin_627b6d3c' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_592c2254 from 'nuxt_plugin_iconplugin_592c2254' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_deviceplugin_3197b17e from 'nuxt_plugin_deviceplugin_3197b17e' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_setstorage_0de3acc8 from 'nuxt_plugin_setstorage_0de3acc8' // Source: ../plugins/set-storage (mode: 'all')
import nuxt_plugin_vuelazyload_e6901296 from 'nuxt_plugin_vuelazyload_e6901296' // Source: ../plugins/vue-lazyload (mode: 'all')
import nuxt_plugin_jsonld_320ccf54 from 'nuxt_plugin_jsonld_320ccf54' // Source: ../plugins/jsonld (mode: 'all')
import nuxt_plugin_axios_2228ef02 from 'nuxt_plugin_axios_2228ef02' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_ab_170fd5d6 from 'nuxt_plugin_ab_170fd5d6' // Source: ../plugins/ab (mode: 'client')
import nuxt_plugin_apiservice_f07798e4 from 'nuxt_plugin_apiservice_f07798e4' // Source: ../plugins/api-service (mode: 'all')
import nuxt_plugin_filters_2abc1387 from 'nuxt_plugin_filters_2abc1387' // Source: ../plugins/filters (mode: 'all')
import nuxt_plugin_routingPlugin_f15bb3b6 from 'nuxt_plugin_routingPlugin_f15bb3b6' // Source: ../plugins/routingPlugin (mode: 'all')
import nuxt_plugin_smartstepback_4fe633d0 from 'nuxt_plugin_smartstepback_4fe633d0' // Source: ../plugins/smart-step-back (mode: 'all')
import nuxt_plugin_nuxtswiperplugin_82e70236 from 'nuxt_plugin_nuxtswiperplugin_82e70236' // Source: ../plugins/nuxt-swiper-plugin.js (mode: 'client')
import nuxt_plugin_initWS_300edae0 from 'nuxt_plugin_initWS_300edae0' // Source: ../plugins/initWS (mode: 'client')
import nuxt_plugin_setDefaultData_c2f483cc from 'nuxt_plugin_setDefaultData_c2f483cc' // Source: ../plugins/setDefaultData.js (mode: 'all')
import nuxt_plugin_theme_232d5855 from 'nuxt_plugin_theme_232d5855' // Source: ../plugins/theme (mode: 'client')
import nuxt_plugin_onesignal_af1d1410 from 'nuxt_plugin_onesignal_af1d1410' // Source: ../plugins/vuex/one-signal (mode: 'client')
import nuxt_plugin_newmodal_3bcfbccc from 'nuxt_plugin_newmodal_3bcfbccc' // Source: ../plugins/new-modal (mode: 'all')
import nuxt_plugin_routertracker_594798b0 from 'nuxt_plugin_routertracker_594798b0' // Source: ../plugins/router-tracker (mode: 'client')
import nuxt_plugin_globalcomponents_54ec6fe8 from 'nuxt_plugin_globalcomponents_54ec6fe8' // Source: ../plugins/global-components (mode: 'all')
import nuxt_plugin_globaldirectives_04d3720c from 'nuxt_plugin_globaldirectives_04d3720c' // Source: ../plugins/global-directives (mode: 'all')
import nuxt_plugin_globalmixins_495a3408 from 'nuxt_plugin_globalmixins_495a3408' // Source: ../plugins/global-mixins (mode: 'all')
import nuxt_plugin_modal_22cddd39 from 'nuxt_plugin_modal_22cddd39' // Source: ../plugins/modal (mode: 'client')
import nuxt_plugin_media_22c95270 from 'nuxt_plugin_media_22c95270' // Source: ../plugins/media (mode: 'client')
import nuxt_plugin_hotjar_ccafc592 from 'nuxt_plugin_hotjar_ccafc592' // Source: ../plugins/vuex/hotjar (mode: 'client')
import nuxt_plugin_gtmPlugin_6ed250ff from 'nuxt_plugin_gtmPlugin_6ed250ff' // Source: ../plugins/gtmPlugin (mode: 'client')
import nuxt_plugin_initPragmaticLive_2923e33a from 'nuxt_plugin_initPragmaticLive_2923e33a' // Source: ../plugins/initPragmaticLive (mode: 'client')
import nuxt_plugin_checkforpageiniframe_e8a5b22a from 'nuxt_plugin_checkforpageiniframe_e8a5b22a' // Source: ../plugins/check-for-page-in-iframe (mode: 'client')
import nuxt_plugin_pixel_22f5b512 from 'nuxt_plugin_pixel_22f5b512' // Source: ../plugins/pixel (mode: 'all')
import nuxt_plugin_smartico_33f3c220 from 'nuxt_plugin_smartico_33f3c220' // Source: ../plugins/smartico (mode: 'client')
import nuxt_plugin_timer_232de9d1 from 'nuxt_plugin_timer_232de9d1' // Source: ../plugins/timer (mode: 'client')
import nuxt_plugin_fingerprint_620db270 from 'nuxt_plugin_fingerprint_620db270' // Source: ../plugins/fingerprint (mode: 'client')
import nuxt_plugin_worker_4804c272 from 'nuxt_plugin_worker_4804c272' // Source: ../plugins/worker (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    return this.$root.$options.$nuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"afterLeave":function() {
      window.scrollTo(0, 0);
    },"name":"fade-page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"lang":"uk"},"title":"beton","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0, interactive-widget=resizes-content"},{"hid":"description","name":"description","content":"## Build Setup"},{"name":"format-detection","content":"telephone=no"},{"name":"theme-color","content":"#070707"},{"name":"msapplication-TileColor","content":"#070707"},{"name":"apple-mobile-web-app-status-bar-style","content":"black-translucent"},{"name":"apple-mobile-web-app-capable","content":"yes"},{"name":"apple-mobile-web-app-title","content":"BETON"},{"name":"apple-mobile-web-app-status-bar-style","content":"black"},{"name":"msapplication-TileImage","content":"\u002Fandroid-chrome-192x192.png"},{"name":"robots","content":"index, follow"}],"link":[{"type":"image\u002Fpng","sizes":"32x32","rel":"icon","href":"\u002Ffavicon-32x32.png"},{"type":"image\u002Fpng","sizes":"192x192","rel":"icon","href":"\u002Fandroid-chrome-192x192.png"},{"type":"image\u002Fpng","sizes":"512x512","rel":"icon","href":"\u002Fandroid-chrome-512x512.png"},{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002Fapple-touch-icon.png"},{"rel":"manifest","href":"\u002Fmanifest.json"}],"script":[{"src":"https:\u002F\u002Fcdn.onesignal.com\u002Fsdks\u002Fweb\u002Fv16\u002FOneSignalSDK.page.js","body":true,"defer":true},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.defer=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);}})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":""}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.server && typeof nuxt_plugin_sentryserver_0f71d9b7 === 'function') {
    await nuxt_plugin_sentryserver_0f71d9b7(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_ac8f2fa2 === 'function') {
    await nuxt_plugin_sentryclient_ac8f2fa2(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_e914cc3c === 'function') {
    await nuxt_plugin_recaptcha_e914cc3c(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_3ce82489 === 'function') {
    await nuxt_plugin_gtm_3ce82489(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtsvgsprite_0e574451 === 'function') {
    await nuxt_plugin_nuxtsvgsprite_0e574451(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_cc633c94 === 'function') {
    await nuxt_plugin_vuescrollto_cc633c94(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_76ee54b0 === 'function') {
    await nuxt_plugin_pluginutils_76ee54b0(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_7baa98f3 === 'function') {
    await nuxt_plugin_pluginrouting_7baa98f3(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_577f2f5c === 'function') {
    await nuxt_plugin_pluginmain_577f2f5c(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_0486bcf3 === 'function') {
    await nuxt_plugin_axios_0486bcf3(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_627b6d3c === 'function') {
    await nuxt_plugin_metaplugin_627b6d3c(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_592c2254 === 'function') {
    await nuxt_plugin_iconplugin_592c2254(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_3197b17e === 'function') {
    await nuxt_plugin_deviceplugin_3197b17e(app.context, inject)
  }

  if (typeof nuxt_plugin_setstorage_0de3acc8 === 'function') {
    await nuxt_plugin_setstorage_0de3acc8(app.context, inject)
  }

  if (typeof nuxt_plugin_vuelazyload_e6901296 === 'function') {
    await nuxt_plugin_vuelazyload_e6901296(app.context, inject)
  }

  if (typeof nuxt_plugin_jsonld_320ccf54 === 'function') {
    await nuxt_plugin_jsonld_320ccf54(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2228ef02 === 'function') {
    await nuxt_plugin_axios_2228ef02(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_ab_170fd5d6 === 'function') {
    await nuxt_plugin_ab_170fd5d6(app.context, inject)
  }

  if (typeof nuxt_plugin_apiservice_f07798e4 === 'function') {
    await nuxt_plugin_apiservice_f07798e4(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_2abc1387 === 'function') {
    await nuxt_plugin_filters_2abc1387(app.context, inject)
  }

  if (typeof nuxt_plugin_routingPlugin_f15bb3b6 === 'function') {
    await nuxt_plugin_routingPlugin_f15bb3b6(app.context, inject)
  }

  if (typeof nuxt_plugin_smartstepback_4fe633d0 === 'function') {
    await nuxt_plugin_smartstepback_4fe633d0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtswiperplugin_82e70236 === 'function') {
    await nuxt_plugin_nuxtswiperplugin_82e70236(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_initWS_300edae0 === 'function') {
    await nuxt_plugin_initWS_300edae0(app.context, inject)
  }

  if (typeof nuxt_plugin_setDefaultData_c2f483cc === 'function') {
    await nuxt_plugin_setDefaultData_c2f483cc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_theme_232d5855 === 'function') {
    await nuxt_plugin_theme_232d5855(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_onesignal_af1d1410 === 'function') {
    await nuxt_plugin_onesignal_af1d1410(app.context, inject)
  }

  if (typeof nuxt_plugin_newmodal_3bcfbccc === 'function') {
    await nuxt_plugin_newmodal_3bcfbccc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_routertracker_594798b0 === 'function') {
    await nuxt_plugin_routertracker_594798b0(app.context, inject)
  }

  if (typeof nuxt_plugin_globalcomponents_54ec6fe8 === 'function') {
    await nuxt_plugin_globalcomponents_54ec6fe8(app.context, inject)
  }

  if (typeof nuxt_plugin_globaldirectives_04d3720c === 'function') {
    await nuxt_plugin_globaldirectives_04d3720c(app.context, inject)
  }

  if (typeof nuxt_plugin_globalmixins_495a3408 === 'function') {
    await nuxt_plugin_globalmixins_495a3408(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_modal_22cddd39 === 'function') {
    await nuxt_plugin_modal_22cddd39(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_media_22c95270 === 'function') {
    await nuxt_plugin_media_22c95270(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_hotjar_ccafc592 === 'function') {
    await nuxt_plugin_hotjar_ccafc592(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtmPlugin_6ed250ff === 'function') {
    await nuxt_plugin_gtmPlugin_6ed250ff(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_initPragmaticLive_2923e33a === 'function') {
    await nuxt_plugin_initPragmaticLive_2923e33a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_checkforpageiniframe_e8a5b22a === 'function') {
    await nuxt_plugin_checkforpageiniframe_e8a5b22a(app.context, inject)
  }

  if (typeof nuxt_plugin_pixel_22f5b512 === 'function') {
    await nuxt_plugin_pixel_22f5b512(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_smartico_33f3c220 === 'function') {
    await nuxt_plugin_smartico_33f3c220(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_timer_232de9d1 === 'function') {
    await nuxt_plugin_timer_232de9d1(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_fingerprint_620db270 === 'function') {
    await nuxt_plugin_fingerprint_620db270(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_worker_4804c272 === 'function') {
    await nuxt_plugin_worker_4804c272(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, (err) => {
        // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
        if (!err._isRouter) return reject(err)
        if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
